import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { useState } from 'react';
import { usePublisher } from '@magalu/mixer-publisher';
import { usePrebasketToggle } from '@magalu/mixer-utils';
import { useClient } from '../context';
import { BasketQuery, PreBasketQuery } from '../query';
import { AddToCartMutation, AddToPreBasketMutation, DeleteFromItemList, RemoveItemFromBasket, RemoveServicesMutation, UpdateListItem } from '../mutation';
var errorEnum = {
  INSUFFICIENT_STOCK: 'Estoque insuficiente',
  NOT_FOUND: 'Produto não encontrado'
};
var useCart = function useCart() {
  var client = useClient();
  var enabledPreBasket = usePrebasketToggle();
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var setLoading = function setLoading(loading) {
    return publish('page:loading', loading);
  };
  function addToCartMutation(_x) {
    return _addToCartMutation.apply(this, arguments);
  }
  function _addToCartMutation() {
    _addToCartMutation = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(variables) {
      var id, productId, sellerId, extensions, _variables$quantity, quantity, services, partnerId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = variables.id, productId = variables.productId, sellerId = variables.sellerId, extensions = variables.extensions, _variables$quantity = variables.quantity, quantity = _variables$quantity === void 0 ? '1' : _variables$quantity, services = variables.services, partnerId = variables.partnerId;
            return _context.abrupt("return", client.mutate({
              mutation: AddToCartMutation,
              variables: {
                extensions: extensions,
                id: id,
                partnerId: partnerId,
                productId: productId,
                quantity: Number.isNaN(Number(quantity)) ? '1' : quantity,
                sellerId: sellerId,
                services: services == null ? void 0 : services.map(String)
              }
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _addToCartMutation.apply(this, arguments);
  }
  function updateItemListMutation(_x2) {
    return _updateItemListMutation.apply(this, arguments);
  }
  function _updateItemListMutation() {
    _updateItemListMutation = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(variables) {
      var productId, quantity, extras, item, stwu;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            productId = variables.productId, quantity = variables.quantity, extras = variables.extras, item = variables.item, stwu = variables.stwu;
            return _context2.abrupt("return", client.mutate({
              context: {
                headers: stwu ? {
                  'x-customer-id': stwu
                } : undefined
              },
              mutation: UpdateListItem,
              variables: {
                body: {
                  extras: extras,
                  name: item.title,
                  price: item.price,
                  quantity: Number(quantity)
                },
                navigationId: productId,
                type: 'pre_basket'
              }
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _updateItemListMutation.apply(this, arguments);
  }
  function addToPreBasketMutation(_x3) {
    return _addToPreBasketMutation.apply(this, arguments);
  }
  function _addToPreBasketMutation() {
    _addToPreBasketMutation = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(variables) {
      var sellerId, extensions, _variables$quantity2, quantity, services, stwu, channelId, extras, item;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            sellerId = variables.sellerId, extensions = variables.extensions, _variables$quantity2 = variables.quantity, quantity = _variables$quantity2 === void 0 ? '1' : _variables$quantity2, services = variables.services, stwu = variables.stwu, channelId = variables.channelId, extras = variables.extras, item = variables.item;
            return _context3.abrupt("return", client.mutate({
              context: {
                headers: stwu ? {
                  'x-customer-id': stwu
                } : undefined
              },
              mutation: AddToPreBasketMutation,
              variables: {
                body: {
                  channelId: channelId,
                  createdAt: new Date().toISOString(),
                  extras: {
                    extensions: extensions,
                    extras: extras,
                    selected: true,
                    sellerId: sellerId || 'magazineluiza',
                    services: (services == null ? void 0 : services.map(function (service) {
                      return {
                        description: service.description,
                        id: String(service.id),
                        price: service.price
                      };
                    })) || []
                  },
                  id: item.id,
                  name: item.title,
                  price: item.price,
                  quantity: Number(quantity) || 1,
                  type: 'pre_basket'
                },
                upsert: true
              }
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _addToPreBasketMutation.apply(this, arguments);
  }
  function deleteFromItemListMutation(_x4) {
    return _deleteFromItemListMutation.apply(this, arguments);
  }
  function _deleteFromItemListMutation() {
    _deleteFromItemListMutation = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(variables) {
      var productId, stwu;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            productId = variables.productId, stwu = variables.stwu;
            return _context4.abrupt("return", client.mutate({
              context: {
                headers: stwu ? {
                  'x-customer-id': stwu
                } : undefined
              },
              mutation: DeleteFromItemList,
              variables: {
                navigationId: productId,
                type: 'pre_basket'
              }
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _deleteFromItemListMutation.apply(this, arguments);
  }
  function removeItemFromBasketMutation(_x5) {
    return _removeItemFromBasketMutation.apply(this, arguments);
  }
  function _removeItemFromBasketMutation() {
    _removeItemFromBasketMutation = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5(variables) {
      var id, productId, seller;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            id = variables.id, productId = variables.productId, seller = variables.seller;
            return _context5.abrupt("return", client.mutate({
              mutation: RemoveItemFromBasket,
              variables: {
                basketId: id,
                input: {
                  itemSku: productId,
                  seller: seller
                }
              }
            }));
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _removeItemFromBasketMutation.apply(this, arguments);
  }
  function callMutationAddToCart(_x6, _x7) {
    return _callMutationAddToCart.apply(this, arguments);
  }
  function _callMutationAddToCart() {
    _callMutationAddToCart = _asyncToGenerator(_regeneratorRuntime().mark(function _callee6(variables, options) {
      var _response$data, _response$data$addToI, _response$data2, _response$data2$updat, mutation, response, _yield$addToCartMutat, result;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!enabledPreBasket) {
              _context6.next = 6;
              break;
            }
            mutation = options.updatePreBasket ? updateItemListMutation : addToPreBasketMutation;
            _context6.next = 4;
            return mutation(variables, options);
          case 4:
            response = _context6.sent;
            return _context6.abrupt("return", {
              cartId: undefined,
              status: ((_response$data = response.data) == null ? void 0 : (_response$data$addToI = _response$data.addToItemList) == null ? void 0 : _response$data$addToI.status) || ((_response$data2 = response.data) == null ? void 0 : (_response$data2$updat = _response$data2.updateListItem) == null ? void 0 : _response$data2$updat.status)
            });
          case 6:
            _context6.next = 8;
            return addToCartMutation(variables);
          case 8:
            _yield$addToCartMutat = _context6.sent;
            result = _yield$addToCartMutat.data.addToCart;
            return _context6.abrupt("return", result);
          case 11:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _callMutationAddToCart.apply(this, arguments);
  }
  function callMutationRemoveItem(_x8) {
    return _callMutationRemoveItem.apply(this, arguments);
  }
  function _callMutationRemoveItem() {
    _callMutationRemoveItem = _asyncToGenerator(_regeneratorRuntime().mark(function _callee7(variables) {
      var _response$data4;
      var _response$data3, _response, response;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (!enabledPreBasket) {
              _context7.next = 5;
              break;
            }
            _context7.next = 3;
            return deleteFromItemListMutation(variables);
          case 3:
            _response = _context7.sent;
            return _context7.abrupt("return", _response == null ? void 0 : (_response$data3 = _response.data) == null ? void 0 : _response$data3.deleteFromItemList);
          case 5:
            _context7.next = 7;
            return removeItemFromBasketMutation(variables);
          case 7:
            response = _context7.sent;
            return _context7.abrupt("return", response == null ? void 0 : (_response$data4 = response.data) == null ? void 0 : _response$data4.removeItems);
          case 9:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _callMutationRemoveItem.apply(this, arguments);
  }
  function fetchCart(_x9) {
    return _fetchCart.apply(this, arguments);
  }
  function _fetchCart() {
    _fetchCart = _asyncToGenerator(_regeneratorRuntime().mark(function _callee8(_ref) {
      var cartId, customerId, _yield$client$query, itemList, _yield$client$query2, getBasket;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            cartId = _ref.cartId, customerId = _ref.customerId;
            if (!enabledPreBasket) {
              _context8.next = 9;
              break;
            }
            if (customerId) {
              _context8.next = 4;
              break;
            }
            throw new Error('Informe o customerId');
          case 4:
            _context8.next = 6;
            return client.query({
              context: {
                headers: {
                  'x-customer-id': customerId
                }
              },
              fetchPolicy: 'no-cache',
              query: PreBasketQuery,
              variables: {
                type: 'pre_basket'
              }
            });
          case 6:
            _yield$client$query = _context8.sent;
            itemList = _yield$client$query.data.itemList;
            return _context8.abrupt("return", {
              items: itemList.items.map(function (item) {
                var _item$item$financialS;
                return {
                  quantity: item.quantity,
                  services: (_item$item$financialS = item.item.financialServices) == null ? void 0 : _item$item$financialS.offers.map(function (offer) {
                    return {
                      id: offer.id
                    };
                  }),
                  sku: item.id
                };
              }),
              totals: {
                itemsQuantity: itemList.items.reduce(function (acc, item) {
                  return acc + item.quantity;
                }, 0)
              }
            });
          case 9:
            _context8.next = 11;
            return client.query({
              fetchPolicy: 'no-cache',
              query: BasketQuery,
              variables: {
                basketId: cartId
              }
            });
          case 11:
            _yield$client$query2 = _context8.sent;
            getBasket = _yield$client$query2.data.getBasket;
            return _context8.abrupt("return", _extends({}, getBasket));
          case 14:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _fetchCart.apply(this, arguments);
  }
  function addToCart() {
    return _addToCart.apply(this, arguments);
  }
  function _addToCart() {
    _addToCart = _asyncToGenerator(_regeneratorRuntime().mark(function _callee9() {
      var variables,
        options,
        result,
        cartId,
        status,
        totals,
        _args9 = arguments;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            variables = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
            options = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {
              loading: true,
              updatePreBasket: false
            };
            if (options.loading) {
              setLoading(true);
            }
            _context9.prev = 3;
            _context9.next = 6;
            return callMutationAddToCart(variables, options);
          case 6:
            result = _context9.sent;
            if (!(result === null)) {
              _context9.next = 9;
              break;
            }
            throw new Error('Não foi possível adicionar ao carrinho');
          case 9:
            cartId = result.id, status = result.status, totals = result.totals;
            if (['OK', 'success'].includes(status)) {
              _context9.next = 12;
              break;
            }
            throw new Error(errorEnum[status]);
          case 12:
            setData({
              cartId: cartId,
              status: status,
              totals: totals
            });
            return _context9.abrupt("return", {
              data: {
                cartId: cartId,
                status: status,
                totals: totals
              },
              error: null
            });
          case 16:
            _context9.prev = 16;
            _context9.t0 = _context9["catch"](3);
            setError(_context9.t0.message);
            return _context9.abrupt("return", {
              data: null,
              error: _context9.t0.message
            });
          case 20:
            _context9.prev = 20;
            setLoading(false);
            return _context9.finish(20);
          case 23:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[3, 16, 20, 23]]);
    }));
    return _addToCart.apply(this, arguments);
  }
  function removeServices() {
    return _removeServices.apply(this, arguments);
  }
  function _removeServices() {
    _removeServices = _asyncToGenerator(_regeneratorRuntime().mark(function _callee10() {
      var variables,
        id,
        productId,
        seller,
        services,
        _yield$client$mutate,
        result,
        _args10 = arguments;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            variables = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
            id = variables.id, productId = variables.productId, seller = variables.seller, services = variables.services;
            setLoading(true);
            _context10.prev = 3;
            _context10.next = 6;
            return client.mutate({
              mutation: RemoveServicesMutation,
              variables: {
                basketId: id,
                input: {
                  itemSku: productId,
                  seller: seller,
                  serviceIds: services
                }
              }
            });
          case 6:
            _yield$client$mutate = _context10.sent;
            result = _yield$client$mutate.data.removeServices;
            if (!(result === null)) {
              _context10.next = 10;
              break;
            }
            throw new Error('Não foi possível remover os serviços do carrinho');
          case 10:
            return _context10.abrupt("return", {
              error: null
            });
          case 13:
            _context10.prev = 13;
            _context10.t0 = _context10["catch"](3);
            setError(_context10.t0.message);
            return _context10.abrupt("return", {
              error: _context10.t0.message
            });
          case 17:
            _context10.prev = 17;
            setLoading(false);
            return _context10.finish(17);
          case 20:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[3, 13, 17, 20]]);
    }));
    return _removeServices.apply(this, arguments);
  }
  function removeItem() {
    return _removeItem.apply(this, arguments);
  }
  function _removeItem() {
    _removeItem = _asyncToGenerator(_regeneratorRuntime().mark(function _callee11() {
      var variables,
        options,
        result,
        _args11 = arguments;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            variables = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
            options = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {
              loading: true
            };
            if (options.loading) {
              setLoading(true);
            }
            _context11.prev = 3;
            _context11.next = 6;
            return callMutationRemoveItem(variables);
          case 6:
            result = _context11.sent;
            if (!(result === null)) {
              _context11.next = 9;
              break;
            }
            throw new Error('Não foi possível remover o item do carrinho');
          case 9:
            return _context11.abrupt("return", {
              error: null
            });
          case 12:
            _context11.prev = 12;
            _context11.t0 = _context11["catch"](3);
            setError(_context11.t0.message);
            return _context11.abrupt("return", {
              error: _context11.t0.message
            });
          case 16:
            _context11.prev = 16;
            setLoading(false);
            return _context11.finish(16);
          case 19:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[3, 12, 16, 19]]);
    }));
    return _removeItem.apply(this, arguments);
  }
  function getCart(_x10, _x11) {
    return _getCart.apply(this, arguments);
  }
  function _getCart() {
    _getCart = _asyncToGenerator(_regeneratorRuntime().mark(function _callee12(cartId, customerId) {
      var cartData;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            setLoading(true);
            _context12.prev = 1;
            if (!(!cartId && !customerId)) {
              _context12.next = 4;
              break;
            }
            throw new Error('Informe o cartId ou customerId');
          case 4:
            _context12.next = 6;
            return fetchCart({
              cartId: cartId,
              customerId: customerId
            });
          case 6:
            cartData = _context12.sent;
            setData({
              cart: cartData
            });
            return _context12.abrupt("return", {
              data: {
                cart: cartData
              },
              error: null
            });
          case 11:
            _context12.prev = 11;
            _context12.t0 = _context12["catch"](1);
            setError(_context12.t0.message);
            return _context12.abrupt("return", {
              data: null,
              error: _context12.t0.message
            });
          case 15:
            _context12.prev = 15;
            setLoading(false);
            return _context12.finish(15);
          case 18:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[1, 11, 15, 18]]);
    }));
    return _getCart.apply(this, arguments);
  }
  return [{
    addToCart: addToCart,
    getCart: getCart,
    removeItem: removeItem,
    removeServices: removeServices
  }, {
    data: data,
    error: error
  }];
};
export default useCart;